__turbopack_context__.v({
  "buttonWrapper": "login-module-scss-module__QZ16wW__buttonWrapper",
  "container": "login-module-scss-module__QZ16wW__container",
  "dashboardImage": "login-module-scss-module__QZ16wW__dashboardImage",
  "eyeToggle": "login-module-scss-module__QZ16wW__eyeToggle",
  "forgotPassword": "login-module-scss-module__QZ16wW__forgotPassword",
  "forgotPasswordLink": "login-module-scss-module__QZ16wW__forgotPasswordLink",
  "form": "login-module-scss-module__QZ16wW__form",
  "formInner": "login-module-scss-module__QZ16wW__formInner",
  "imagebox": "login-module-scss-module__QZ16wW__imagebox",
  "imageboxLogo": "login-module-scss-module__QZ16wW__imageboxLogo",
  "imageboxLogoContent": "login-module-scss-module__QZ16wW__imageboxLogoContent",
  "imageboxLogoSubText": "login-module-scss-module__QZ16wW__imageboxLogoSubText",
  "imageboxLogoText": "login-module-scss-module__QZ16wW__imageboxLogoText",
  "inputField": "login-module-scss-module__QZ16wW__inputField",
  "labelEmail": "login-module-scss-module__QZ16wW__labelEmail",
  "labelPassword": "login-module-scss-module__QZ16wW__labelPassword",
  "linkAccent": "login-module-scss-module__QZ16wW__linkAccent",
  "loadingWrapper": "login-module-scss-module__QZ16wW__loadingWrapper",
  "loginForm": "login-module-scss-module__QZ16wW__loginForm",
  "loginLoader": "login-module-scss-module__QZ16wW__loginLoader",
  "loginSubmitButton": "login-module-scss-module__QZ16wW__loginSubmitButton",
  "logoMobile": "login-module-scss-module__QZ16wW__logoMobile",
  "orEmail": "login-module-scss-module__QZ16wW__orEmail",
  "orEmailLine": "login-module-scss-module__QZ16wW__orEmailLine",
  "orEmailWrapper": "login-module-scss-module__QZ16wW__orEmailWrapper",
  "passwordRow": "login-module-scss-module__QZ16wW__passwordRow",
  "passwordToggle": "login-module-scss-module__QZ16wW__passwordToggle",
  "promoDashboardImage": "login-module-scss-module__QZ16wW__promoDashboardImage",
  "registerLink": "login-module-scss-module__QZ16wW__registerLink",
  "registerLinkAnchor": "login-module-scss-module__QZ16wW__registerLinkAnchor",
  "registerLinkText": "login-module-scss-module__QZ16wW__registerLinkText",
  "submitButton": "login-module-scss-module__QZ16wW__submitButton",
  "title": "login-module-scss-module__QZ16wW__title",
});
